
/***************************
* Authentication API Routes
***************************/

export const SANCTUM = {
    _COOKIE:            'sanctum/csrf-cookie',
    _USER:              'api/user',
    _SIGN_OUT:          ''
}

export const AUTH = {
    SS1_BENEFACTORS:    '/api/v1/identity/auth/_/ss1/benefactor',
    SS0_BENEFACTORS:    '/api/v1/identity/auth/_/ss0/benefactor',
    BENEFACTOR_STATUS:  '/api/v1/identity/auth/_/benefactor/status',
    GOOGLE_AUTH:        '/api/v1/identity/auth/auth/google/redirect',
};


export const TEMP = {
    SS2_BENEFACTORS:    '/api/temp/v1/identity/auth/_/ss2/benefactor',
}

export const PEOPLE_PROFILE ={ 
    GROUP_COLLECTION:   '/api/v1/c/iam/identity/people-profile/groups',
    GROUP_RESOURCE:     '/api/v1/c/iam/identity/people-profile/:group',
    DEFINIT_MANIFEST:   '/api/v1/c/iam/identity/people-profile/definitions/manifest',
    CREATE_DEFINITION:  '/api/v1/c/iam/identity/people-profile/definitions',
    DEFINITION_DETAILS: '/api/v1/c/iam/identity/people-profile/definitions/:definition',
    DEFINITION_OPTIONS: '/api/v1/c/iam/identity/people-profile/definitions/:definition/options',
    OPTIONS_RESOURCE:   '/api/v1/c/iam/identity/people-profile/definitions/:definition/options/:option',
}





/* 
 * Asset Management API Routes
*/
export const ASSETS = {
    ALL_CATEGORIES:     '/api/v1/assets-management/categories',
    CATEGORY_TYPES:     '/api/v1/assets-management/:category/types',
    ASSET_FORMS:        '/api/v1/assets-management/:category/:type/forms',
    FORM_ATTRIBUTES:    '/api/v1/assets-management/:category/:type/attributes',
    DISCARD_DRAFT:      '/api/v1/assets-management/:category/:type/discard',
    FORM_VERSIONS:      '/api/v1/assets-management/:category/:type/versions',
    PUBLISH_FORM:       '/api/v1/assets-management/:category/:type/publication',
    PREVIEW_FORM:       '/api/v1/assets-management/:category/:type/:version',
}

export const L0GXP = {
    FILTER:             '/api/v1/c/log-xplr/users/_/filter',
    SEARCH:             '/api/v1/c/log-xplr/entries/_/search',
    EVENTS_LIST:        '/api/v1/c/log-xplr/entires/events/list',
    EVENT_DETAILS:      '/api/v1/c/log-xplr/entries/view/:logId',
}

export const IDAM = {
    PROVIDERS_IDX:      '/api/v1/c/iam/identity/providers/index',
    PROVIDER_CATALOG:   '/api/v1/c/iam/identity/providers/catalog',
    PROVIDER_CONFIG:    '/api/v1/c/iam/identity/providers/:slug',

    ATTR_GROUPS:        '/api/v1/c/iam/user/attribute-groups',
    ATTR_GROUP_DETAIL:  '/api/v1/c/iam/user/attribute-groups/:group',
    ATTR_DEFINITIONS:   '/api/v1/c/iam/user/attributes',




    USR_ATTR_LISTING:   '/api/v1/c/iam/user/attributes',
    USR_ATTR_CATALOG:   '/api/v1/c/iam/user/attributes/catalog',
    USR_ATTR_ADDITION:  '/api/v1/c/iam/user/attributes/:attribute',
    REFERENCE_ENTITY:   '/api/v1/c/iam/user/attributes/:attribute/reference-entity',
}

export const USER = {
    MANAGED_ACCOUNTS:   '/api/v1/c/iam/user/accounts/managed'
}